<template>
  <v-card
    class="mx-auto mb-4"
    :loading="loadingInfo"
    flat
  >
    <v-toolbar dense flat>
      <v-toolbar-title class="flex text-center">
        Thông tin Liên hệ
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-list v-if="system">
        <v-list-item-group>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon
                class="primary lighten-1"
                dark
              >
                mdi-map-marker
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="text-body-2">
                {{system.dia_chi}}
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon
                class="primary lighten-1"
                dark
              >
                mdi-phone
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="text-body-2">
                {{system.so_dien_thoai}}
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon
                class="primary lighten-1"
                dark
              >
                mdi-email
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="text-body-2">
                {{system.email}}
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon
                class="primary lighten-1"
                dark
              >
                mdi-clock-time-nine-outline
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="text-body-2">
                T2 - T6 8:00 - 17:00
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: "ContactInfo",
    data() {
      return {
        loadingInfo: false,
      };
    },
    computed: {
      ...mapState([
        'system'
      ])
    }
  };
</script>